const translation = {
  nav: {
    home: '首页',
    categories: '分类浏览',
    about: '关于我们',
    search: '搜索域名...',
  },
  home: {
    heroTitle: '日韩在线永久域名',
    heroSubtitle: '稳定不丢失的访问入口',
    heroDesc: '为您提供最新、最稳定的日韩在线域名收录，告别频繁换址烦恼，永久书签收藏，随时畅享日韩正版内容。',
    heroCTA: '立即探索',
    heroSecondary: '了解更多',
    statsDomains: '收录域名',
    statsCategories: '内容分类',
    statsUsers: '服务用户',
    statsUpdate: '每日更新',
    featuredTitle: '推荐域名',
    featuredSubtitle: '精选最稳定、最受欢迎的日韩在线域名',
    categoryTitle: '内容分类',
    categorySubtitle: '按内容类型浏览日韩在线域名',
    viewAll: '查看全部',
    faqTitle: '常见问题',
    faqSubtitle: '关于日韩在线永久域名的常见疑问解答',
    ctaTitle: '立即收藏，永不丢失',
    ctaDesc: '将本站加入书签，您就拥有了一个永不过期的日韩在线内容访问入口。域名每日更新维护，确保您的访问从不中断。',
    ctaButton: '收藏本站',
  },
  category: {
    title: '分类浏览',
    subtitle: '按内容类型筛选日韩在线域名',
    allCategories: '全部分类',
    domainCount: '个域名',
    backToHome: '返回首页',
    noDomains: '该分类暂无域名',
    filterByStatus: '状态筛选',
    allStatus: '全部状态',
    online: '在线',
    offline: '离线',
  },
  article: {
    publishDate: '发布时间',
    updateDate: '更新时间',
    author: '作者',
    visits: '阅读量',
    tags: '标签',
    relatedDomains: '相关域名',
    relatedArticles: '推荐文章',
    backToList: '返回列表',
    prevArticle: '上一篇',
    nextArticle: '下一篇',
    noArticle: '文章不存在',
  },
  about: {
    title: '关于我们',
    brandIntro: '品牌介绍',
    brandIntroContent: '日韩在线永久域名成立于2020年，是国内领先的日韩在线内容域名收录平台。我们致力于为广大日韩内容爱好者提供最新、最稳定的域名访问入口，让每一位用户都能轻松找到并访问心仪的日韩在线内容。',
    brandMission: '我们的使命',
    brandMissionContent: '让每一个喜爱日韩文化的用户，都能拥有一个稳定、可靠、永不过期的内容访问入口。无论您喜欢日剧、韩剧、动漫、音乐还是综艺，都能在这里找到最优质的域名资源。',
    brandVision: '我们的愿景',
    brandVisionContent: '成为中文互联网最值得信赖的日韩在线域名收录平台，用专业和诚信服务每一位用户，让"换域名"这件事成为历史。',
    reputation: '信誉展示',
    reputationContent: '我们自2020年成立以来，始终坚持每日更新域名状态，确保收录信息的准确性和时效性。平台已累计服务超过50万用户，域名在线率保持在98%以上。我们承诺：所有收录域名均经过人工审核，绝不收录恶意或欺诈站点。',
    contactTitle: '联系我们',
    contactSubtitle: '如有任何问题或建议，欢迎通过以下方式联系我们',
    contactEmail: '电子邮箱',
    contactWechat: '微信公众号',
    contactQQ: 'QQ群',
    contactForm: '留言反馈',
    contactFormName: '您的称呼',
    contactFormEmail: '电子邮箱',
    contactFormMessage: '留言内容',
    contactFormSubmit: '提交留言',
    contactFormSuccess: '留言提交成功！我们会尽快回复您。',
    contactFormError: '提交失败，请稍后重试。',
    address: '公司地址',
    addressContent: '广东省广州市天河区体育西路111号建和中心',
    domainUpdate: '域名更新维护',
    teamIntro: '团队介绍',
    teamIntroContent: '我们的团队由一群热爱日韩文化的年轻人组成，包括技术开发、内容运营和域名监控三个小组。我们7×24小时轮班监控域名状态，确保第一时间发现并更新失效域名。',
    statsTitle: '平台数据',
    stats1Label: '收录域名',
    stats1Value: '100+',
    stats2Label: '服务用户',
    stats2Value: '50万+',
    stats3Label: '在线率',
    stats3Value: '98%',
    stats4Label: '成立年限',
    stats4Value: '6年+',
  },
  common: {
    online: '在线',
    offline: '离线',
    visit: '访问',
    copySuccess: '已复制到剪贴板',
    copyFailed: '复制失败',
    more: '查看更多',
    loading: '加载中...',
    noData: '暂无数据',
    backToTop: '回到顶部',
    searchPlaceholder: '搜索域名或关键词...',
    breadcrumbHome: '首页',
    footerCopyright: '© 2026 日韩在线永久域名 版权所有',
    footerDesc: '日韩在线永久域名 - 稳定不丢失的访问入口。本站提供的域名均来自互联网公开信息，仅供学习交流使用。',
  },
  seo: {
    homeTitle: '日韩在线永久域名 - 稳定不丢失的访问入口',
    homeDesc: '日韩在线永久域名为您提供最新、最稳定的日韩在线域名收录，告别频繁换址烦恼，永久书签收藏，随时畅享日韩正版内容，域名持续更新维护，确保访问从不中断。',
    homeKeywords: '日韩在线永久域名,日韩在线永久域名最新地址,日韩视频永久域名,日韩在线不封域名,日韩永久免费域名入口',
    categoryTitle: '{{category}} - 日韩在线永久域名',
    categoryDesc: '浏览日韩在线{{category}}永久域名收录，最新最全的{{category}}访问入口，稳定可靠永不丢失。',
    articleTitle: '{{title}} - 日韩在线永久域名',
    articleDesc: '{{excerpt}}',
    aboutTitle: '关于我们 - 日韩在线永久域名',
    aboutDesc: '日韩在线永久域名是国内领先的日韩在线内容域名收录平台，成立于2020年，已服务超过50万用户，提供最新最稳定的域名访问入口。',
  },
};

export default translation;